import { atom } from "recoil"

const authState = atom({
  key: "auth",
  default: localStorage.getItem("user") ? true : false,
})

export default authState
